var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.959 50.194c0 17.819-14.446 32.265-32.266 32.265S18.428 68.013 18.428 50.194c0-17.82 14.445-32.266 32.266-32.266 17.819 0 32.264 14.446 32.264 32.266",
    fill: "#AED8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.693 12.964c-20.528 0-37.23 16.701-37.23 37.23 0 20.528 16.702 37.229 37.23 37.229 20.528 0 37.23-16.701 37.23-37.23 0-20.528-16.702-37.229-37.23-37.229m0 79.422C27.428 92.386 8.5 73.46 8.5 50.194 8.5 26.928 27.428 8 50.693 8 73.96 8 92.886 26.928 92.886 50.194c0 23.265-18.927 42.192-42.193 42.192",
    fill: "#2D2D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.684 37.466-1.706 1.688c-5.957 5.97-12.332 12.808-18.282 18.844l-8.493-6.994-1.838-1.538-3.056 3.713 1.856 1.519 10.2 8.4 1.669 1.387 1.556-1.537c6.45-6.463 13.45-14.035 19.8-20.4l1.688-1.707-3.394-3.375z",
    fill: "#359EAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.684 37.466-1.706 1.688c-5.957 5.97-12.332 12.808-18.282 18.844l-8.493-6.994-1.838-1.538-3.056 3.713 1.856 1.519 10.2 8.4 1.669 1.387 1.556-1.537c6.45-6.463 13.45-14.035 19.8-20.4l1.688-1.707-3.394-3.375z",
    stroke: "#359EAD",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Checkmark.c2927d19857f7f834e03b2ba6f9c2392.svg";
export { ForwardRef as ReactComponent };